import { HttpContextToken } from "@angular/common/http";

export const LOADING_ELEMENT = new HttpContextToken<string>(() => '');
export const POSITION_TOP_VALUE = new HttpContextToken<string>(() => '');